<div id="{{ id }}"
     class="d-print-none {{ defaultClasses }}"
     role="alert"
     [attr.aria-hidden]="ariaState"
     aria-live="polite"
     [@fadeInOut]>
  <span class="prompt-link-container"
     [attr.aria-hidden]="ariaState">
    {{ downloadPrompt }}&nbsp;
    <a #link
       [href]="url"
     [attr.tabindex]="tabIndexState"
       class="download-link red-text-link"
       [class.has-download-icon]="displayIcon"
       (click)="linkClicked()"
       [attr.download]="filename"
       [attr.target]="target">
    {{ downloadLinkText }}
    <zbp-icon
      aria-hidden="true"
      *ngIf="displayIcon"
      [iconName]="zbpIconNames.download">
    </zbp-icon>
  </a>
  </span>
</div>
